import React, { Suspense, lazy } from 'react';
import { Route } from 'react-router-dom';
import PermissionGuard2 from '../../Layout/PermissionGuard2';

import LoadingOverlay from 'react-loading-overlay';
import FadeLoader from 'react-spinners/FadeLoader';
LoadingOverlay.propTypes = undefined;

// Lazy load components for better performance
const SubscriptionList = lazy(() => import('../SubscriptionTab/Subscription'));

/**
 * Store module routes
 * @param {Object} props - Component props
 * @returns {JSX.Element} - Store routes
 */
const SubscriptionRoute = (props) => {
    const { history } = props;

    return (
        <>
            <Route
                exact
                path="/:lng/settings/subscription"
                render={() => (
                    <React.Fragment>
                        <Suspense fallback={<Loading />}>
                            <SubscriptionList history={history} />
                        </Suspense>
                    </React.Fragment>
                )}
            />
        </>
    );
};
function Loading() {
    return (
        <>
            <div className="wrapper">
                <span>Loading</span>
            </div>
        </>
    );
}
export default SubscriptionRoute;
